<template>
  <b-modal
    id="quickbooks-successful-connected"
    ref="quickbooks-successful-connected"
    size="purchase-successful"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <i class="subscribe-icon" />
      <h4>{{ label.get('quickbook_account_integrated_successfully') }}</h4>
    </div>
    <div class="content-wrapper">
      <p>
        {{ label.get('quickbook_account_integrated_description') }}
      </p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="atto-btn submit go-to"
        @click="close"
      >
        {{ label.get('go_to_account') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
    export default {
        name: "QuickBooksSuccessfulConnectedComponent",
        mounted() {
            this.$refs['quickbooks-successful-connected'].show();
        },
        methods: {
            close() {
              let query = Object.assign({}, this.$route.query);
              delete query.quickbook;
              this.$router.replace({ query });
              this.$root.$emit('hideQuickBooksSuccessfulConnected');
            }
        }
    }
</script>

<style lang="scss">
    @media (max-width: 768px) {

        .modal-purchase-successful {
            max-width: 100% !important;

            .modal-content{
                .modal-head {
                    padding-top: 48px;
                }

                .modal-body{
                    .content-wrapper{
                        padding: 16px 20px 32px;
                    }
                }

                .modal-footer{
                    padding: 0 20px 25px;
                    button.atto-btn{
                        width: 100%;
                        max-width: 100%;

                        &.go-to{
                            width: 160px;
                        }
                    }
                }
            }


        }
    }
</style>